import fetch from 'auth/FetchInterceptor'

const LogService = {}
// prettier-ignore
LogService.getAuditLogsWitUserIdDynamic = function (params) {
    // params : userId
    return fetch({
        url: process.env.REACT_APP_API_URL+`portal/AuditLogs/GetUserAuditLogsDynamic/${params.userId}?index=${params.index}&size=10`,
        method: 'post',
        data: params.finalQuery,
    })
}

LogService.getAuditLogsDynamic = function (params) {
    // params : userId
    return fetch({
        url: process.env.REACT_APP_API_URL+`portal/AuditLogs/GetAuditLogsDynamic?index=${params.index}&size=10`,
        method: 'post',
        data: params.finalQuery,
    })
}

LogService.getOcppAuditLogsDynamic = function (params) {
    // params : userId
    return fetch({
        url: process.env.REACT_APP_API_URL+`portal/OcppAuditLog/GetOcppAuditLogsDynamic?index=${params.index}&size=10`,
        method: 'post',
        data: params.finalQuery,
    })
}

LogService.getDiagnosticFiles = function (params) {
    // params : deviceId
    return fetch({
        url: process.env.REACT_APP_API_URL+'portal/Ftp/GetLogs',
        method: 'get',
        params: {
            chargePointId: params
        }
    })
}

LogService.getMaintenanceLogs = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL+`messageTrace/MaintenanceLogs?ChargePointId=${params.chargePointId}&index=${params.index}&size=10`,
        method: 'get',
        params,
    })
}

LogService.getMaintenanceLogsDynamic = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL+`messageTrace/MaintenanceLogs/GetMaintenanceLogsWithAttachments?index=${params.index}&size=10`,
        method: 'post',
        data: params.finalQuery,
    })
}

LogService.getMaintenanceLogsExcel = function (data) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'messageTrace/MaintenanceLogs/MaintenanceLogsExcel',
        method: 'post',
        data: data,
        responseType: 'blob',
    })
}

LogService.getAuditLogsWithUserIdExcel = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + `portal/AuditLogs/GetUserAuditLogsExcel?userId=${params.userId}`,
        method: 'post',
        data: params.finalQuery,
        responseType: 'blob',
    })
}

LogService.getAuditLogsExcel = function (data) {
    return fetch({
        url: process.env.REACT_APP_API_URL + `portal/AuditLogs/GetAuditLogsExcel`,
        method: 'post',
        data: data,
        responseType: 'blob',
    })
}

LogService.getOcppLogsExcel = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + `messageTrace/OcppLogs/GetLogsRequestResponseExcel?StartDate=${params.startDate}&EndDate=${params.endDate}&ChargePointId=${params.chargePointId}&Types=${params.types}`,
        method: 'get',
        data: params,
        responseType: 'blob',
    })
}

LogService.getOcppAuditLogsExcel = function (data) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/OcppAuditLog/GetOcppAuditLogsExcel',
        method: 'post',
        data: data,
        responseType: 'blob',
    })
}

LogService.logPageVisit = function (data) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'ocpp/Visits/log_page_visit',
        method: 'post',
        data: data,
    })
}
export default LogService